<div class="exception-body access">
    <!-- <img src="assets/layout/images/logo-white.svg" alt="diamond-layout" class="logo"> -->

    <div class="exception-content">
        <div class="exception-title">ACCÈS REFUSÉ</div>
        <div class="exception-detail">Vous n'avez pas les permissions necéssaires pour afficher cette page.</div>
        <a href="/">Retour à l'accueil</a>
    </div>
</div>
